import { useState } from "react";
import { motion } from "framer-motion";

const schools = [
  {
    date: "May 2024 - Present",
    title: "University Of Windsor",
    subTitle: "Master Of Applied Computing\n(AI Specialization)",
  },
  {
    date: "August 2018 - May 2022",
    title: "Mumbai University",
    subTitle: "Bachelor of Engineering Computer Engineering",
  },
];

function EducationTile() {
  const [animationComplete, setAnimationComplete] = useState(
    new Array(schools.length).fill(false)
  );

  const handleAnimationComplete = (index) => {
    setAnimationComplete((prev) => {
      const newStatus = [...prev];
      newStatus[index] = true;
      return newStatus;
    });
  };

  return (
    <>
      <ol className="mt-7 overflow-hidden space-y-8 font-poppins">
        {schools.map((element, index) => (
          <li
            key={index}
            className={`${
              index !== schools.length - 1 && animationComplete[index]
                ? "relative flex-1 after:content-[''] after:w-0.5 after:h-full after:bg-purple-500 after:inline-block after:absolute after:-bottom-8 after:left-2 after:opacity-0 after:animate-fadeIn"
                : ""
            }`}
          >
            <p className="flex items-start font-medium w-full">
              <motion.div
                key={index}
                exit={{ scale: 1 }}
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ duration: 1 }}
                onAnimationComplete={() => handleAnimationComplete(index)}
              >
                <span className="w-4 h-4 mt-2 aspect-square bg-purple-500 border-2 border-transparent rounded-full flex justify-center items-center mr-3 text-sm text-white"></span>
              </motion.div>
              <div className="block">
                <motion.div
                  key={index}
                  exit={{ scale: 1 }}
                  initial={{ opacity: 0, x: -100 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  <p className="text-gray-300 text-xl font-bold mb-2">
                    {element.title}
                  </p>
                </motion.div>
                <motion.div
                  key={index}
                  exit={{ scale: 1 }}
                  initial={{ opacity: 0, x: -100 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.7 }}
                >
                  <p className="text-sm text-purple-400 max-w-xs mb-4">
                    {element.date}
                    <br />
                  </p>
                </motion.div>
                <motion.div
                  key={index}
                  exit={{ scale: 1 }}
                  initial={{ opacity: 0, x: -100 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.9 }}
                >
                  <p className="text-sm text-gray-300 max-w-xs mb-4">
                    {element.subTitle}
                    <br />
                  </p>
                </motion.div>
              </div>
            </p>
          </li>
        ))}
      </ol>
    </>
  );
}

export default EducationTile;
